import { observer } from "mobx-react-lite";
import { useState, useEffect } from "react";
import {useAlbumStore, useProfilPlayerStore, useProfilStore} from "../stores/useStore";
import "../style/Community.css";
import Header from "../components/general/Header";
import Leaderboard from "../components/profilPlayer/Leaderboard";
import AlbumPresentation from "../components/profilPlayer/AlbumOfTheDay";
// images
import vinyleImg from "/images/vinyle.svg";

const Community = observer(() => {
  const profilPlayerStore = useProfilPlayerStore();
  const profilStore = useProfilStore();
  const albumStore = useAlbumStore();
  const [showIntroImage, setShowIntroImage] = useState(true);

  useEffect(() => {
    // IMAGE INTRO
    const timeout = setTimeout(() => {
      setShowIntroImage(false);
    }, 1000); // durée de l'animation


    return () => {
      clearTimeout(timeout);
      // profilPlayerStore.resetProfilPlayerList();
    }
  }, []);







  return (
    <main className={`community_main ${showIntroImage && `albumsintro`}`}>
      {showIntroImage && (
        <img
          src={vinyleImg}
          alt="Intro"
          className="community_intro-img animate"
        ></img>
      )}
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      <div className="community_content">
        {albumStore?.isLoaded?.albumOfTheDay? <AlbumPresentation className="community_albumOfTheDay" album={albumStore?.albumOfTheDay} group={albumStore.getGroupById(albumStore?.albumOfTheDay?.groupId)} />:null}
        <Leaderboard className="community_leaderboard" profilPlayerStore={profilPlayerStore}/>
      </div>
    </main>
  );
});

export default Community;
